// ✅ Central navigation config — Header (desktop) aur MobileMenu dono isi se render hote hain.
// Corporate Companies / Strategic Programs ke items yahin add/update karein.
import { companyLink } from "../../data/companyLinks";

export interface NavItem {
  id: number;
  title: string;
  link: string;
  submenu?: NavItem[];
}

export const navMenus: NavItem[] = [
  { id: 1, title: "Home", link: "/" },
  { id: 2, title: "About", link: "/about" },
  {
    id: 3,
    title: "Corporate Companies",
    link: "#",
    submenu: [
      // Source: KOT Corporate Statutes — Article 18
      // Links companyLinks.ts se — har company apne alag domain par deploy hoti hai
      { id: 31, title: "Digital Systems", link: companyLink("digital-systems") },
      { id: 32, title: "AppForge", link: companyLink("appforge") },
      { id: 33, title: "Venture Xcelerator", link: companyLink("venture-xcelerator") },
      { id: 34, title: "EpiTech", link: companyLink("epitech") },
      { id: 35, title: "The Founders TX", link: companyLink("the-founders-tx") },
      { id: 36, title: "Commerce X", link: companyLink("commerce-x") },
      { id: 37, title: "Growth IQ", link: companyLink("growth-iq") },
      { id: 38, title: "Visual Systems", link: companyLink("visual-systems") },
      { id: 39, title: "Platform Systems", link: companyLink("platform-systems") },
      { id: 40, title: "Flawless X", link: companyLink("flawless-x") },
    ],
  },
  {
    id: 4,
    title: "Strategic Programs",
    link: "#",
    submenu: [
      // Source: KOT Corporate Statutes — Article 19
      { id: 41, title: "Challenge X", link: "/programs/challenge-x" },
      { id: 42, title: "Platform 9¾", link: "/programs/platform-9-34" },
      { id: 43, title: "Madad Farma", link: "/programs/madad-farma" },
      { id: 44, title: "Her X", link: "/programs/her-x" },
      { id: 45, title: "Saqafat", link: "/programs/saqafat" },
    ],
  },
  { id: 5, title: "Contact", link: "/#contact" },
];

export const headerCta = {
  text: "Get in Touch",
  link: "/#contact",
};
